import { render, staticRenderFns } from "./ModalRegraDeCalculoIncluirContrato.vue?vue&type=template&id=5461667b"
import script from "./ModalRegraDeCalculoIncluirContrato.vue?vue&type=script&lang=ts"
export * from "./ModalRegraDeCalculoIncluirContrato.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports